import React, { useEffect, useState } from 'react';
import { Table, Button, Spin, Modal, Form, Select, Tag, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CloseOutlined } from '@ant-design/icons';
import { Link, RouteComponentProps, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSalaireGroupsByEcoleId, initializeSalaireGroup, reset, getSalaireDashboard, updateSalaireGroupStatus } from './salaire.reducer';
import { ISalaireDashboard, SalaireParams, StatutSalaire } from 'app/shared/model/salaire.model';
import { TextFormat } from 'react-jhipster';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { getEcole } from '../ecole/ecole.reducer';
import { useCheckIsAnneeInactive } from 'app/hooks/useCheckIsAnneeActive';

const SalaireGroup = ({ match }: RouteComponentProps<SalaireParams>) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { ecoleid } = useParams<{ ecoleid: string }>();
  const [isProcessing, setProcessing] = useState(false);
  const [isCreatingSalaire, setCreatingSalaire] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [loadingIds, setLoadingIds] = useState([]);

  const getDashbord = id => {
    if (loadingIds.includes(id)) return;
    setLoadingIds(prev => [...prev, id]);
    dispatch(getSalaireDashboard(id))
      .then(res => {
        const { totalNet, totalFrais } = res.payload as ISalaireDashboard;
        setDashboardData(prevState => ({
          ...prevState,
          [id]: {
            totalNet,
            totalFrais,
          },
        }));
        setLoadingIds(prev => prev.filter(loadingId => loadingId !== id));
      })
      .catch(error => {
        console.error('Erreur lors de la récupération du tableau de bord :', error);
        setLoadingIds(prev => prev.filter(loadingId => loadingId !== id));
      });
  };

  const salaireGroupList = useAppSelector(state => state.salaire.salaireGroupEntities);
  const loading = useAppSelector(state => state.salaire.loading);
  const inactiveAnnee = useCheckIsAnneeInactive(match.params.anneeScolaireId);

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    dispatch(getEcole(ecoleid));
    dispatch(getSalaireGroupsByEcoleId({ ecoleId: ecoleid, anneeScolaireId: match.params.anneeScolaireId }));
    dispatch(updateSalaireGroupStatus({ ecoleId: ecoleid, anneeScolaireId: match.params.anneeScolaireId }));
    return () => {
      dispatch(reset());
    };
  }, [ecoleid]);

  const saveSalaire = values => {
    dispatch(initializeSalaireGroup({ ecoleId: ecoleid, mois: values.mois, anneeScolaireId: match.params.anneeScolaireId }));
    setCreatingSalaire(false);
    form.resetFields();
  };

  const moisListe = [
    'JANVIER',
    'FEVRIER',
    'MARS',
    'AVRIL',
    'MAI',
    'JUIN',
    'JUILLET',
    'AOUT',
    'SEPTEMBRE',
    'OCTOBRE',
    'NOVEMBRE',
    'DECEMBRE',
  ];

  const handleInitiateSalaire = () => {
    const modal = Modal.info({
      title: (
        <div>
          <span>Nouvelle Paye</span>
          <Button type="text" onClick={() => modal.destroy()} style={{ float: 'right' }}>
            <CloseOutlined style={{ color: '#F28E19' }} />
          </Button>
        </div>
      ),
      content: (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vh' }}>
          <div style={{ width: '400px' }}>
            <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} layout="vertical" size="large" onFinish={saveSalaire}>
              <Form.Item
                rules={[
                  {
                    required: true,
                  },
                ]}
                label="Salaire du mois"
                name={'mois'}
                required
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Select placeholder="Choisissez un mois" style={{ width: '100%' }} optionFilterProp="children">
                  {moisListe.map((mois, index) => {
                    const isMonthYearDisabled = salaireGroupList.some(
                      salaireA => salaireA.mois === mois && +salaireA.annee === currentYear
                    );

                    return (
                      <Option key={index} value={mois} disabled={isMonthYearDisabled}>
                        {mois} {currentYear}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Form>
          </div>
        </div>
      ),
      okText: 'Suivant',
      onOk() {
        try {
          setProcessing(true);
          form.submit();
        } catch (error) {
          console.error(error);
        } finally {
          setProcessing(false);
        }
      },
      width: '50%',
      okButtonProps: { disabled: isProcessing, style: { background: '#F28E19', color: 'white', border: '1px solid #F28E19' } },
    });
  };
  const Montant = ({ value }) => {
    const formattedValue = value.toLocaleString('fr-FR');
    return <strong>{formattedValue} FCFA</strong>;
  };
  const renderMontant = id => {
    if (!dashboardData[id]) {
      getDashbord(id);
      return <Spin tip="Chargement..." />;
    }
    const { totalNet, totalFrais } = dashboardData[id];
    return <Montant value={totalNet + totalFrais} />;
  };

  const renderOption = (id, record) => {
    return (
      <Space size="middle">
        <Button type="primary" style={{ height: 30, width: 45 }}>
          <Link to={`/salaires/${match.params.ecoleid}/${match.params.anneeScolaireId}/${record.id}/list`}>
            <FontAwesomeIcon icon="eye" />{' '}
          </Link>
        </Button>

        <Button
          type="primary"
          style={{
            height: 30,
            width: 45,
            backgroundColor: record.statutSalaire === 'PAYEE' ? '#ccc' : 'red',
            borderColor: record.statutSalaire === 'PAYEE' ? '#ccc' : 'red',
          }}
          disabled={record.statutSalaire === StatutSalaire.PAYEE || record.statutSalaire === StatutSalaire.EN_ATTENTE || inactiveAnnee}
        >
          <Link to={`/salaires/${match.params.ecoleid}/${match.params.anneeScolaireId}/${record.id}/delete`}>
            <FontAwesomeIcon icon="trash" />
          </Link>
        </Button>
      </Space>
    );
  };

  const columns = [
    {
      title: 'Salaire',
      dataIndex: 'moisAnnee',
      key: 'moisAnnee',
      render: text => <strong>{text}</strong>,
      align: 'center' as const,
    },
    {
      title: 'Date de Création',
      dataIndex: 'dateDebut',
      key: 'dateDebut',
      align: 'center' as const,
      render: dateDebut => <TextFormat type="date" value={dateDebut} format={APP_DATE_FORMAT} />,
    },
    {
      title: 'Montant total',
      dataIndex: 'id',
      key: 'totalNet',
      render: id => renderMontant(id),
    },
    {
      title: 'Statut',
      dataIndex: 'statutSalaire',
      key: 'statutSalaire',
      align: 'center' as const,
      render: statutSalaire =>
        statutSalaire === 'EN_ATTENTE' ? (
          <Tag color="red">En attente</Tag>
        ) : statutSalaire === 'PAYEE' ? (
          <Tag color="green">Payé</Tag>
        ) : (
          <Tag color="blue">{statutSalaire}</Tag>
        ),
    },
    {
      title: 'Option',
      dataIndex: 'id',
      key: 'id',
      align: 'center' as const,
      render: renderOption,
    },
  ];

  const data = salaireGroupList.map((salaireL, i) => ({
    id: salaireL.id,
    mois: salaireL.mois,
    annee: salaireL.annee,
    dateDebut: salaireL.dateDebut,
    statutSalaire: salaireL.statut,
    moisAnnee: `${salaireL.mois} ${salaireL.annee}`,
  }));

  const sortedData = data.sort((a, b) => {
    return moisListe.indexOf(a.mois) - moisListe.indexOf(b.mois);
  });

  return (
    <div>
      <h2>Gestion salariales du personnel</h2>
      <div style={{ margin: '0 auto', textAlign: 'center' }}>
        <div style={{ textAlign: 'right' }}>
          <Button
            onClick={handleInitiateSalaire}
            disabled={isCreatingSalaire || inactiveAnnee}
            style={{
              background: isCreatingSalaire || inactiveAnnee ? '#ccc' : '#F28E19',
              color: 'white',
              borderRadius: '8px',
              border: `1px solid ${isCreatingSalaire || inactiveAnnee ? '#ccc' : '#F28E19'}`,
            }}
          >
            {isCreatingSalaire ? (
              <Spin />
            ) : (
              <>
                <FontAwesomeIcon icon="plus" style={{ marginRight: '8px' }} />
                Nouvelle Paye
              </>
            )}
          </Button>
        </div>
        &nbsp;
        <div className="table-responsive">
          <Spin spinning={loading} tip="Chargement...">
            <Table columns={columns} dataSource={sortedData} bordered pagination={false} />
          </Spin>
        </div>
        <div style={{ marginBottom: '50px' }}></div>
      </div>
    </div>
  );
};

export default SalaireGroup;
